import CityPageTemplate from "../city-template/CityPageTemplate";
import { elkGroveConfig } from "./data";

export default function ElkGrovePage() {
  return <CityPageTemplate config={elkGroveConfig} />;
}